import {
  CButton,
  CFormInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import EmailQuotaService from 'src/service/EmailQuotaService'

const AnnounceFinalEmail = (props) => {
  const sendEmails = () => {
    EmailQuotaService.getFantasyResult().then((res) => {
      if (res.success) {
        ToastComponent(res.message, 'success')
      } else {
        ToastComponent(res.message, 'error')
      }
    })
  }

  // setup test email modal
  const [visible, setVisible] = useState(false)
  const [testEmail, setTestEmail] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSendTestEmail = () => {
    if (!testEmail) {
      ToastComponent('Please enter an email address', 'error')
      return
    }
    const data = { testEmail }
    setLoading(true)
    EmailQuotaService.testAnnountFinalResult(data).then((res) => {
      setLoading(false)
      ToastComponent(res.message, res.success ? 'success' : 'error')
      if (res.success) {
        setVisible(false)
        setTestEmail('')
      }
    })
  }
  return (
    <>
      <table className="main-table table innertable">
        <thead>
          <tr>
            <th width="30%">Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Announce Final Result</td>

            <td>
              <CButton onClick={() => sendEmails()}>Send Now</CButton>&nbsp;&nbsp;
              <CButton color="info" onClick={() => setVisible(true)}>
                Test Email
              </CButton>
            </td>
          </tr>
        </tbody>
      </table>
      {/* Test Email Modal */}
      <CModal visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Send Test Email</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CFormInput
            type="email"
            placeholder="Enter test email address"
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
          />
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSendTestEmail} disabled={loading}>
            {loading ? 'Sending...' : 'Send'}
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default AnnounceFinalEmail
